export default __webpack_public_path__ + "static/media/Zing 2.0.e6a1baa7.gif";